import { getApiClient } from '@src/services/api-client'
import { MutationFunction, useMutation } from '@tanstack/react-query'
import { makeGetCsv } from '../make-api'

const REPORT_ALL_APPLICATION = '/ReportAllApplication'

const reportAllApplicationApiLegacy = makeGetCsv(REPORT_ALL_APPLICATION)

async function downloadReportAllApplication() {
  const apiClient = getApiClient()
  return reportAllApplicationApiLegacy(apiClient)
}

export function useReportAllApplicationExport(): [MutationFunction<void, void>, boolean] {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: downloadReportAllApplication,
  })

  return [mutateAsync, isPending]
}

